/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../banking/account_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "FolderRecommendation": {
                    "fields": {
                      "category": {
                        "type": ".squareup.banking.SavingsAccountMetadata.Category",
                        "id": 1,
                        "rule": "optional"
                      },
                      "percentageContributionBps": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.FolderRecommendation) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents an individual on an SFS ApplicationFlow.
 * --
 *
 * SOURCE FolderRecommendation @ squareup/sfs/external/models/folder_recommendation.proto at 10:1
 */
export const FolderRecommendation = $root.lookupType('squareup.sfs.external.models.FolderRecommendation');
fixType(FolderRecommendation);
Builder.createAndAttachToType(FolderRecommendation);